/**
 * Why an agent list looks the way it does.
 *
 * Named generically rather than `emptyReason` so a later revision can attach a
 * reason to a non-empty list without a second field. Each member discloses one
 * boolean condition and nothing more - a count would leak the shared ElevenLabs
 * workspace's size to a company with nothing assigned.
 *
 * `FetchFailed` is the one member the server never sends. The frontend sets it
 * when the request itself fails, so that one field answers "why does this list
 * look like this" for every case, server-side or not.
 */
export enum VoiceAIAgentReason {
  NoAssignment = 'no-assignment',
  EmptyWorkspace = 'empty-workspace',
  FetchFailed = 'fetch-failed',
}
